import { gql } from "graphql-tag";
import { CategoryFragment } from "entity/category/api/fragments";
import {
  CountersFragment,
  AdvertisedCountersFragment,
} from "entity/counters/api/fragments";

export const ProductSummaryFragment = gql`
  fragment ProductSummaryFragment on ProductSummary {
    id
    lastPrice
    alias
    sku
    availableForOrder
    availableForBooking
    hasOnlyBookingPrices
    canPayOnPickup
    brand {
      alias
      name
    }
    badges {
      description
      title
      type
      dateEnd
      src
      color
    }
    maxQuantity
    expirationDate
    deliveryDate
    discount
    url
    image
    isFavorite
    price
    priceOld
    seoBasketText
    seoPriceText
    priceTypeID
    name
    pickupDate
    rating
    mnns {
      href
      title
    }
    producer
    category {
      ...CategoryFragment
    }
    producerCountry
    warning
    counters {
      ...CountersFragment
    }
    patternBlock
    bitrixID
    patternBlockPosition
    isAdv
    reviewsDisabled
    prices {
      dateExpired
      discount
      maxQuantity
      price
      priceOld
      priceTypeID
      dateExpiredOpened
      isExpirating
      hasPrefix
    }
    isBundle
    bundleItemsSimple {
      id
      quantity
      shortName
    }
  }
  ${CategoryFragment}
  ${AdvertisedCountersFragment}
  ${CountersFragment}
`;

export const ProductShortFragment = gql`
  fragment ProductShortFragment on ProductShort {
    id
    alias
    availableForOrder
    availableForBooking
    hasOnlyBookingPrices
    hasPricePrefix
    canPayOnPickup
    badges {
      description
      title
      type
      dateEnd
      src
      color
    }
    category {
      path
    }
    maxQuantity
    expirationDate
    url
    image
    isFavorite
    priceTypeID
    name
    counters {
      ...CountersFragment
    }
    brand {
      alias
      name
    }
    bitrixID
    isBundle
  }
  ${CountersFragment}
`;

export const ProductCardRegularFragment = gql`
  fragment ProductCardRegularFragment on ProductSummary {
    id
    lastPrice
    alias
    sku
    availableForOrder
    availableForBooking
    hasOnlyBookingPrices
    canPayOnPickup
    maxQuantity
    expirationDate
    deliveryDate
    discount
    url
    image
    isFavorite
    price
    priceOld
    seoBasketText
    seoPriceText
    priceTypeID
    name
    pickupDate
    rating
    producerCountry
    warning
    isAdv
    isBundle
    brand {
      alias
      name
    }
    badges {
      description
      title
      type
      dateEnd
      src
      color
    }
    category {
      id
      name
      path
    }
    counters {
      ...CountersFragment
    }
    prices {
      dateExpired
      discount
      maxQuantity
      price
      priceOld
      priceTypeID
      dateExpiredOpened
      isExpirating
      hasPrefix
    }
    bundleItemsSimple {
      id
      quantity
      shortName
    }
  }
  ${CountersFragment}
`;
